import { render, staticRenderFns } from "./FeeRecharge.vue?vue&type=template&id=5b267bba&scoped=true&"
import script from "./FeeRecharge.vue?vue&type=script&lang=js&"
export * from "./FeeRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b267bba",
  null
  
)

export default component.exports